/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Widget } from 'features/types'
import { TextWidget as TextWidgetType } from 'schemas/TextWidgetSchema'
import { useDashboardWidgetSetting } from '../../../hooks/useDashboardState'
import PlaceHolder from '../../share/PlaceHolder'
import StyledTextWidget from './index.css'

const TextWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<TextWidgetType>(widgetId)

  const text = widgetSetting.text || ''
  const lines = text.split(/\r\n|\n|\r/gm)

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <PlaceHolder>{error.message}</PlaceHolder>}>
      <StyledTextWidget>
        {lines.map((line, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`${line}${idx}`}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </StyledTextWidget>
    </ErrorBoundary>
  )
}

export default TextWidget
